import { get } from "./apiClient";

export default {
  async getAll() {
    return await get(`products`);
  }
};
